/**
 * API 참고 문서: https://podotree.atlassian.net/wiki/spaces/PSD/pages/3158606091/API+v2
 */
export enum MenuUidVo {
  Taste = 10000,
  Webtoon = 10010,
  WebNovel = 10011,
  Book = 10016,
}
